var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_cof.js
// module id = 203
// module chunks = 16